export const INPUT_WORD_LIMIT = 25;
export const TEXTAREA_WORD_LIMIT = 50;

const WORD_PATTERN = /\S+/g;

export const countWords = (value = '') => String(value).trim().match(WORD_PATTERN)?.length || 0;

export const limitWords = (value = '', maxWords = INPUT_WORD_LIMIT) => {
  const text = String(value);
  const matches = [...text.matchAll(WORD_PATTERN)];
  if (matches.length <= maxWords) return text;
  const lastAllowed = matches[maxWords - 1];
  return text.slice(0, lastAllowed.index + lastAllowed[0].length);
};

export const getTextEntryWordLimit = (element) => {
  if (!element || element.disabled || element.readOnly) return null;
  const tagName = element.tagName?.toLowerCase();
  if (tagName === 'textarea') return TEXTAREA_WORD_LIMIT;
  if (tagName !== 'input') return null;

  const type = (element.getAttribute('type') || 'text').toLowerCase();
  const textTypes = new Set(['', 'text', 'search', 'email', 'password', 'tel', 'url']);
  return textTypes.has(type) ? INPUT_WORD_LIMIT : null;
};
